const ACTIVE_EMPLOYEE_STATUS = 'active';
const EMAIL_ADDRESS_PATTERN = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

export interface SettingsEmployee {
  userUuid: string;
  email: string;
  name: string;
  imageUrl?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  status?: string;
}

export function getEmployeeDisplayName(employee: SettingsEmployee) {
  return employee.name || [employee.firstName, employee.lastName].filter(Boolean).join(' ') || employee.email;
}

export function getEmployeeInitials(employee: SettingsEmployee | undefined, fallback: string) {
  const name = employee ? getEmployeeDisplayName(employee) : fallback;
  return getNameInitials(name, fallback);
}

export function getNameInitials(name: string, fallback = '') {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('');
  return (initials || fallback.slice(0, 2)).toUpperCase();
}

export function isActiveEmployee(employee: SettingsEmployee) {
  return !employee.status || employee.status === ACTIVE_EMPLOYEE_STATUS;
}

export function getEmailAddresses(value: string) {
  const emails = value.match(EMAIL_ADDRESS_PATTERN) ?? [];
  return [...new Set(emails.map((email) => email.toLowerCase()))];
}

export function getEmployeesByUserUuid(employees: SettingsEmployee[]) {
  const employeesByUserUuid = new Map<string, SettingsEmployee>();

  for (const employee of employees) {
    if (employee.userUuid) {
      employeesByUserUuid.set(employee.userUuid, employee);
    }
  }

  return employeesByUserUuid;
}
